import { useEffect } from "react";
import { getLocationSummaries } from "../api/location";
import { LocationSummary } from "../models/location";
import { UPDATE_LOCATION_LIST } from "../reducers/actions";
import { useRadarDispatch, useRadarState } from "../reducers/reducers";

export const ADMIN_LOCATION = "00000";
// Location selected in place of the admin pseudo-location, which is not a real store
export const DEFAULT_LOCATION = "00070";

export const useLocationFetch = () => {
  const dispatch = useRadarDispatch();
  const { user } = useRadarState();

  useEffect(() => {
    const getLocations = async () => {
      if (user == null) {
        return;
      }

      const allLocations = await getLocationSummaries();
      let filteredLocations = allLocations;

      const locationNumbers = user["cfa-locations"] || [];
      if (locationNumbers.indexOf(ADMIN_LOCATION) === -1) {
        filteredLocations = locationNumbers
          .map((locationNumber) =>
            allLocations.find(
              (location) => location.locationNumber === locationNumber
            )
          )
          .filter((location): location is LocationSummary => location != null);
      }

      // The admin pseudo-location is not a real store and must not be selectable
      filteredLocations = filteredLocations.filter(
        (location) => location.locationNumber !== ADMIN_LOCATION
      );

      dispatch({ type: UPDATE_LOCATION_LIST, locations: filteredLocations });
    };
    getLocations();
  }, [dispatch, user]);
};
